import i18n from '@/i18n';

export default [
  {
    path: '/groove-widget',
    name: 'groove-widget',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'groove-widget',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('groove_widget')
    },
    component: () => import('../../views/grooveWidget/Index'),
  },
];
